import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table } from 'semantic-ui-react';
import moment from 'moment';
import SettlementCommon from 'components/SettlementList/SettlementCommon';

import numeral from 'numeral';

class TradingResult extends Component {
  renderCompanyInfoTable = (data) => {
    const { providerCompany, receiverCompany } = data;

    return (
      <Table celled>
        <Table.Body>
          <Table.Row>
            <Table.Cell rowSpan={8} className="thead">
              공<br />급<br />자
            </Table.Cell>
            <Table.Cell className="thead">등록번호</Table.Cell>
            <Table.Cell width={3}>{SettlementCommon.bizSerialFormatter(providerCompany.bizSerial)}</Table.Cell>
            <Table.Cell className="thead">종사업장</Table.Cell>
            <Table.Cell width={3}>{providerCompany.bizSubSerial}</Table.Cell>

            <Table.Cell rowSpan={8} className="thead">
              공<br />급<br />받<br />는<br />자
            </Table.Cell>
            <Table.Cell className="thead">등록번호</Table.Cell>
            <Table.Cell width={3}>{SettlementCommon.bizSerialFormatter(receiverCompany.bizSerial)}</Table.Cell>
            <Table.Cell className="thead">종사업장</Table.Cell>
            <Table.Cell width={3}>{receiverCompany.bizSubSerial}</Table.Cell>
          </Table.Row>
          <Table.Row className="first">
            <Table.Cell className="thead">
              상호
              <br />
              (법인명)
            </Table.Cell>
            <Table.Cell>{providerCompany.bizName}</Table.Cell>
            <Table.Cell className="thead">성명</Table.Cell>
            <Table.Cell>{providerCompany.chargeName}</Table.Cell>
            <Table.Cell className="thead">
              상호
              <br />
              (법인명)
            </Table.Cell>
            <Table.Cell>{receiverCompany.bizName}</Table.Cell>
            <Table.Cell className="thead">성명</Table.Cell>
            <Table.Cell>{receiverCompany.chargeName}</Table.Cell>
          </Table.Row>
          <Table.Row className="first">
            <Table.Cell className="thead">
              사업장
              <br />
              주소
            </Table.Cell>
            <Table.Cell colSpan={3}>{providerCompany.address}</Table.Cell>

            <Table.Cell className="thead">
              사업장
              <br />
              주소
            </Table.Cell>
            <Table.Cell colSpan={3}>{receiverCompany.address}</Table.Cell>
          </Table.Row>
          <Table.Row className="first">
            <Table.Cell className="thead">업태</Table.Cell>
            <Table.Cell>{providerCompany.bizCondition}</Table.Cell>
            <Table.Cell className="thead">종목</Table.Cell>
            <Table.Cell>{providerCompany.bizType}</Table.Cell>

            <Table.Cell className="thead">업태</Table.Cell>
            <Table.Cell>{receiverCompany.bizCondition}</Table.Cell>
            <Table.Cell className="thead">종목</Table.Cell>
            <Table.Cell>{receiverCompany.bizType}</Table.Cell>
          </Table.Row>
          <Table.Row className="first">
            <Table.Cell className="thead" rowSpan={2}>
              이메일
            </Table.Cell>
            <Table.Cell colSpan={3} rowSpan={2}>
              {providerCompany.email1}
            </Table.Cell>
            <Table.Cell className="thead">이메일</Table.Cell>
            <Table.Cell colSpan={3}>{receiverCompany.email1}</Table.Cell>
          </Table.Row>
          <Table.Row className="first">
            <Table.Cell className="thead">이메일</Table.Cell>
            <Table.Cell colSpan={3}>{receiverCompany.email2}</Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    );
  };

  renderTradingInfoTable = (data) => {
    return (
      <Table celled>
        <Table.Body>
          <Table.Row className="thead">
            <Table.Cell>거래명세서 번호</Table.Cell>
            <Table.Cell>생성일자</Table.Cell>
            <Table.Cell className="bold">입금요청 금액</Table.Cell>
            <Table.Cell className="bold">입금 요청일</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>{data.taxUnitSeq}</Table.Cell>
            <Table.Cell>{moment(data.regDate).format('YYYY-MM-DD hh:mm:ss')}</Table.Cell>
            <Table.Cell className="bold">{numeral(data.settleAmt).format('0,0')}</Table.Cell>
            <Table.Cell className="bold">{moment(data.depositRequestYmd).format('YYYY-MM-DD')}</Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    );
  };

  invoicePreviewTable = (data) => {
    return (
      <Table celled>
        <Table.Header>
          <Table.Row className="thead">
            <Table.Cell className="bold">발행구분</Table.Cell>
            <Table.Cell className="bold">작성일자</Table.Cell>
            <Table.Cell className="bold">합계금액</Table.Cell>
            <Table.Cell className="bold">상단비고</Table.Cell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {data.itemSumTempAmt !== 0 ? (
            <Table.Row>
              <Table.Cell>1회성 도입비</Table.Cell>
              <Table.Cell>{moment(data.taxInvoiceYmd).format('YYYY-MM-DD')}</Table.Cell>
              <Table.Cell>{numeral(data.itemSumTempAmt).format('0,0')}</Table.Cell>
              <Table.Cell></Table.Cell>
            </Table.Row>
          ) : null}
          {data.serviceAmt !== 0 ? (
            <Table.Row>
              <Table.Cell>월이용료</Table.Cell>
              <Table.Cell>{moment(data.taxInvoiceYmd).format('YYYY-MM-DD')}</Table.Cell>
              <Table.Cell>{numeral(data.serviceAmt).format('0,0')}</Table.Cell>
              <Table.Cell></Table.Cell>
            </Table.Row>
          ) : null}
          {data.itemSumNoTempAmt !== 0 ? (
            <Table.Row>
              <Table.Cell>식당 관리비</Table.Cell>
              <Table.Cell>{moment(data.taxInvoiceYmd).format('YYYY-MM-DD')}</Table.Cell>
              <Table.Cell>{numeral(data.itemSumNoTempAmt).format('0,0')}</Table.Cell>
              <Table.Cell></Table.Cell>
            </Table.Row>
          ) : null}
          <Table.Row>
            <Table.Cell>식대</Table.Cell>
            <Table.Cell>{moment(data.taxInvoiceYmd).format('YYYY-MM-DD')}</Table.Cell>
            <Table.Cell>{numeral(data.taxMealAmt).format('0,0')}</Table.Cell>
            <Table.Cell></Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>합산</Table.Cell>
            <Table.Cell>{moment(data.taxInvoiceYmd).format('YYYY-MM-DD')}</Table.Cell>
            <Table.Cell>{numeral(data.taxAmt).format('0,0')}</Table.Cell>
            <Table.Cell>{data.remark}</Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    );
  };

  renderTradingDetailTable = (data) => {
    return (
      <Table celled className="tradingDetail">
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell style={{ width: '60%' }}>청구서 항목</Table.HeaderCell>
            <Table.HeaderCell>금액</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          <Table.Row className="amt">
            <Table.Cell>일반식대</Table.Cell>
            <Table.Cell>{numeral(data.taxMealAmt).format('0,0')}</Table.Cell>
          </Table.Row>
          {data.itemSumTempAmt !== 0 ? (
            <Table.Row className="plusAmt">
              <Table.Cell>
                <span>(+)</span> 1회성 도입비
              </Table.Cell>
              <Table.Cell>{numeral(data.itemSumTempAmt).format('0,0')}</Table.Cell>
            </Table.Row>
          ) : null}
          {data.serviceAmt !== 0 ? (
            <Table.Row className="plusAmt">
              <Table.Cell>
                <span>(+)</span> 월이용료
              </Table.Cell>
              <Table.Cell>{numeral(data.serviceAmt).format('0,0')}</Table.Cell>
            </Table.Row>
          ) : null}
          {data.itemSumNoTempAmt !== 0 ? (
            <Table.Row className="plusAmt">
              <Table.Cell>
                <span>(+)</span> 식당 관리비
              </Table.Cell>
              <Table.Cell>{numeral(data.itemSumNoTempAmt).format('0,0')}</Table.Cell>
            </Table.Row>
          ) : null}
          <Table.Row className="amt">
            <Table.Cell>세금계산서 발행 총액</Table.Cell>
            <Table.Cell>{numeral(data.taxAmt).format('0,0')}</Table.Cell>
          </Table.Row>
          {data.lowMealAmt !== 0 ? (
            <Table.Row className="plusAmt">
              <Table.Cell>
                <span>(+)</span> 간이과세자 식대
              </Table.Cell>
              <Table.Cell>{numeral(data.lowMealAmt).format('0,0')}</Table.Cell>
            </Table.Row>
          ) : null}
          {data.freeTaxMealAmt !== 0 ? (
            <Table.Row className="plusAmt">
              <Table.Cell>
                <span>(+)</span> 면세사업자 식대
              </Table.Cell>
              <Table.Cell>{numeral(data.freeTaxMealAmt).format('0,0')}</Table.Cell>
            </Table.Row>
          ) : null}
          {data.consignmentAmt !== 0 ? (
            <Table.Row className="plusAmt">
              <Table.Cell>
                <span>(+)</span> 위수탁 별도발행분
              </Table.Cell>
              <Table.Cell>{numeral(data.consignmentAmt).format('0,0')}</Table.Cell>
            </Table.Row>
          ) : null}
          {data.salaryDeductionAmt !== 0 ? (
            <Table.Row className="plusAmt">
              <Table.Cell>
                <span>(+)</span> 임직원 급여공제분
              </Table.Cell>
              <Table.Cell>{numeral(data.salaryDeductionAmt).format('0,0')}</Table.Cell>
            </Table.Row>
          ) : null}
          {data.qpconAmt !== 0 ? (
            <Table.Row className="plusAmt">
              <Table.Cell>
                <span>(+)</span> 큐피콘 식대
              </Table.Cell>
              <Table.Cell>{numeral(data.qpconAmt).format('0,0')}</Table.Cell>
            </Table.Row>
          ) : null}
          {data.storeDirectSettleAmt !== 0 ? (
            <Table.Row className="exceptAmt">
              <Table.Cell>
                <span>(*)</span> 정산안하는 제휴식당
              </Table.Cell>
              <Table.Cell>{numeral(data.storeDirectSettleAmt).format('0,0')}</Table.Cell>
            </Table.Row>
          ) : null}
          <Table.Row className="totalAmt">
            <Table.Cell>총 입금요청액</Table.Cell>
            <Table.Cell>{numeral(data.settleAmt).format('0,0')}</Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    );
  };

  render() {
    let companyInfoTable;
    let tradingInfoTable;
    let tradingDetailTable;
    let invoicePreviewTable;
    const { tradingInfo } = this.props;

    if (tradingInfo && tradingInfo.data) {
      companyInfoTable = this.renderCompanyInfoTable(tradingInfo.data);
      tradingInfoTable = this.renderTradingInfoTable(tradingInfo.data.companyTrading);
      invoicePreviewTable = this.invoicePreviewTable(tradingInfo.data.companyTrading);
      tradingDetailTable = this.renderTradingDetailTable(tradingInfo.data.companyTrading);
    }

    return (
      <div className="trading">
        <div className="table-box" style={{ marginTop: '20px' }}>
          {companyInfoTable}
        </div>
        <div className="table-box" style={{ marginTop: '10px' }}>
          <div className="bold" style={{ marginBottom: '5px', fontSize: '15px', color: 'black' }}>
            세금계산서 발급 예정 내역
          </div>
          {invoicePreviewTable}
        </div>
        <div className="table-box" style={{ marginTop: '10px' }}>
          {tradingInfoTable}
        </div>
        <div className="table-box" style={{ marginTop: '10px' }}>
          {tradingDetailTable}
        </div>
      </div>
    );
  }
}

TradingResult = connect((state) => ({
  tradingInfo: state.settlement.tradingInfo
}))(TradingResult);

export default TradingResult;
